import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LayoutContext } from '../../../contexts/layout.context';

import Head from '../../../components/Head/Head';
import NameForm from '../../../components/Profile/Edit/NameForm/NameForm';
import { useDispatch } from 'react-redux';
import actions from '../../../store/actions';

const EditName = () => {
  const { setLayout } = useContext(LayoutContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = 'Зміна | New Brain';
    setLayout({ page: 'Зміна' });
  }, [setLayout]);

  const goBack = () => {
    navigate('/profile');
    dispatch(actions.profile.profileError({}));
  };

  return (
    <div className="profile container">
      <Head textHead='Зміна імені' goBack={goBack} />
      <div className="profile__content">
        <NameForm />
      </div>
    </div>
  );
};

export default EditName;